<div class="application-log">
    <!-- Loading Spinner -->
    <div v-if="loading" class="text-center p-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="small">Loading application logs...</p>
    </div>

    <!-- Error Message -->
    <div v-else-if="error" class="alert alert-danger">
      {{ error }}
    </div>

    <!-- Timeline Display -->
    <div v-else class="timeline">
      <div class="timeline-container">
        <div class="timeline-line"></div>

        <!-- Loop through application logs -->
        <div
          v-for="(log, index) in application_logs"
          :key="index"
          class="timeline-item mb-2"
        >
          <!-- Icon -->
          <div :class="['timeline-icon', log.type === 'success' ? 'success' : 'error']">
            <i v-if="log.type === 'success'" class="fa fa-check"></i>
            <i v-if="log.type === 'error'" class="fa fa-exclamation-triangle"></i>
          </div>

          <!-- Log Content -->
          <div class="timeline-content w-200 m-0">
            <p class="log-description w-150 small mb-1">
              <strong>{{ log.title }}</strong> {{ log.description }}
            </p>
            <p class="log-user w-150 mb-0 small">
              <strong>Actioned By:</strong> {{ log.user }}
            </p>
            <p class="log-date w-150 small mb-3">
              {{ log.date }} - {{ log.time }}
            </p>
          </div>
        </div>

        <!-- No Logs Found -->
        <div v-if="application_logs.length === 0" class="text-center p-4">
          <p class="small">No logs found for this application</p>
        </div>
      </div>
    </div>
  </div>